export function completeUrl(url) {
  let reg = /^http/;
  let bol = reg.test(url);
  let end = bol ? url : process.env.VUE_APP_BASE_HOST + url;
  return end;
}

export function getUserInfo() { 
  return JSON.parse(localStorage.getItem("userInfo")) ?? {};
}

export function getToken() { 
  let userInfo = JSON.parse(localStorage.getItem("userInfo")) ?? {};
  return userInfo.jwt
}

export function downFileToUrl(fileUrl,fileName) { 
  let ele = window.document.createElement("a")
  ele.href = fileUrl;
  ele.download = fileName;
  ele.click()
}

// 用户是否已登录
export function userIsLogined() {
  return Boolean(Object.entries(JSON.parse(localStorage.getItem("userInfo")) ?? {}).length);
}




// [注册自定义指令合到一起应该写在main.js中]此代码是针对 :src 这种动态地址 （作用：注册一个自定义指令 也就是 v-complete:src=“xxx”  用于判断图片地址是否需要拼接process.env.VUE_APP_BASE_HOST的问题
// 注意：（注册自定义指令时的形参el指该元素img，作用：指令与改元素绑定  ；binding是个对象式指自定义指令的具体信息）

// app.directive("complete", {                        //全局注册complete自定义指令
//     mounted(el, binding, vnode) {                  //mounted生命周期函数里面可以拿到元素（但是指令里面的其他生命周期函数 也可以拿到元素,只是用mounted习惯了）
//       let endSrc = function (url) {                //配置指令的功能
//           let reg = /^http/;
//           let bol = reg.test(url);
//           let end = bol ? url : process.env.VUE_APP_BASE_HOST + url;
//           return end;
//   }
  
//       el.src = endSrc(binding.value);               //img.src = 函数名(url)    把经过判断加工的url赋值给src
//     },
//   });

// 自定义指令的使用：  <img v-complete:src="props.info.img_url" alt="" />



// 原本此自定义指令时分开写在了三个文件里：
// main.js里面 引入了 这个completeDirective，然后使用 app.directive（指令名字，指令配置）   来进行全局注册自定义指令
// 指令配置 写到了一个单独的js文件里面  ———— directive.js里面
// 最后这个directive.js文件里面 使用的方法 又写到了另外一个单独的js文件里面————utils.js